import { UserRowRoleType } from '@modules/users/store/types';
import { CheckRounded } from '@mui/icons-material';
import { Box, MenuItem, Stack, Typography } from '@mui/material';

interface UserRoleMenuItemsProps {
  selectedRole: UserRowRoleType | null;
  onChange: (role: UserRowRoleType) => void;
}

export const UserRoleMenuItems = ({
  selectedRole,
  onChange,
}: UserRoleMenuItemsProps) => {
  const renderMenuItem = (type: UserRowRoleType, description: string) => {
    const isSelectedUserRole = type === selectedRole;

    return (
      <MenuItem
        value={type}
        sx={{ whiteSpace: 'normal' }}
        disabled={isSelectedUserRole}
        onClick={() => onChange(type)}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Stack spacing={0.25}>
            <Typography variant="body2">{type}</Typography>
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          </Stack>
          {isSelectedUserRole && <CheckRounded color="primary" />}
        </Stack>
      </MenuItem>
    );
  };

  return (
    <Box component="div">
      {renderMenuItem(
        UserRowRoleType.Admin,
        'Admins control data flow, manage user access, modify artifacts, and perform all editor tasks',
      )}
      {renderMenuItem(
        UserRowRoleType.Editor,
        'Editors control insights in Enterpret, managing Taxonomy and metadata to simplify insight derivation, excluding user or data control.',
      )}
      {renderMenuItem(
        UserRowRoleType.Member,
        'Members consume insights, create artifacts, subscribe to reports, but don’t control Taxonomy or metadata.',
      )}
      {renderMenuItem(
        UserRowRoleType.Viewer,
        `Viewers have read-only access in Enterpret; they consume artifacts but can't create them.`,
      )}
    </Box>
  );
};
